import { render, staticRenderFns } from "./HeroCommunity.vue?vue&type=template&id=e24dbe36"
import script from "./HeroCommunity.vue?vue&type=script&lang=js"
export * from "./HeroCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports